import { X, Download, MessageCircle, Instagram, Check, Copy } from "lucide-react";
import { useState } from "react";

export const ShareSheet = ({ dataUrl, fileName, caption, onClose }) => {
  const [copied, setCopied] = useState(false);

  const download = () => {
    const link = document.createElement("a");
    link.download = fileName;
    link.href = dataUrl;
    link.click();
  };

  const copyCaption = async () => {
    try {
      await navigator.clipboard.writeText(caption);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  return (
    <div className="feed-modal-backdrop" onClick={onClose} data-testid="share-sheet">
      <div className="share-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="feed-modal-head">
          <div>
            <p className="feed-modal-kicker">SHARE POSTER</p>
            <h3 className="feed-modal-title">Post it to your socials</h3>
          </div>
          <button className="feed-modal-close" onClick={onClose} data-testid="share-sheet-close">
            <X size={18} />
          </button>
        </div>

        <img src={dataUrl} alt="Poster" className="share-thumb" />

        <p className="share-hint">
          Your browser can't attach images to Instagram or WhatsApp directly. Download the PNG first, then upload it in the app.
        </p>

        <div className="share-actions">
          <button className="share-btn share-primary" onClick={download} data-testid="share-download-btn">
            <Download size={16} /> 1. DOWNLOAD PNG
          </button>
          <a
            className="share-btn"
            href={`https://wa.me/?text=${encodeURIComponent(caption)}`}
            target="_blank"
            rel="noreferrer"
            data-testid="share-whatsapp-btn"
          >
            <MessageCircle size={16} /> 2. OPEN WHATSAPP
          </a>
          <a
            className="share-btn"
            href="https://www.instagram.com/"
            target="_blank"
            rel="noreferrer"
            data-testid="share-instagram-btn"
          >
            <Instagram size={16} /> 2. OPEN INSTAGRAM
          </a>
          <button className="share-btn share-ghost" onClick={copyCaption} data-testid="share-copy-caption-btn">
            {copied ? <Check size={16} /> : <Copy size={16} />} {copied ? "COPIED" : "COPY CAPTION"}
          </button>
        </div>
      </div>
    </div>
  );
};
